import React, { useState } from 'react'

import './second.sass'
import Title from '../title'

export default () => {
  const [isActive, handler] = useState(false)
  return (
    <>
      <a href="/portfolio/offices">
        <div
          className="second-hover  animated fadeInLeft"
          style={{
            marginBottom: 30,
          }}
          // onClick={() => handler(true)}
        >
          {/* //restaurants, offices, hotels */}
          <Title>Офисы</Title>
        </div>
      </a>

      <div
        onClick={() => handler(false)}
        className={`container-second ${isActive ? '' : 'hiden'}`}>
        <div className="main"></div>
        <div className="first"></div>
        <div className="second"></div>
      </div>
    </>
  )
}
